export const getStudyImageClassName = (
  isIOSMeshesStudy: boolean,
  studyPreviewSrc?: string,
  baseClass?: string,
  fallbackClass?: string,
) => {
  return studyPreviewSrc && !isIOSMeshesStudy ? baseClass : fallbackClass;
};
